import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <h1>Sobre mí</h1>
      <p>
        Soy <strong>Max Uriel Sánchez Díaz</strong>, ingeniero en Computación casi egresado de la UAM Cuajimalpa.
      </p>
      <p>
        Desde muy joven, mi pasión por la tecnología y la innovación me impulsó a especializarme en el desarrollo de software, el diseño de interfaces y la arquitectura de sistemas. Esta vocación se plasma en mi proyecto terminal, <strong>MAXCOMGAMES: Comercio Electrónico para la Venta de Videojuegos</strong>, donde fusiono conocimientos y habilidades para crear una plataforma intuitiva, segura y eficiente en el mundo del comercio electrónico.
      </p>
      <p>
        A lo largo de mi formación, he aprendido a integrar la teoría con la práctica, enfrentando desafíos que me han permitido crecer tanto profesional como personalmente. Mi enfoque es desarrollar soluciones tecnológicas que satisfagan las necesidades actuales del mercado y anticipen las demandas del futuro.
      </p>
      <p>
        Creo firmemente en la mejora continua, el aprendizaje constante y el trabajo colaborativo, valores esenciales para afrontar los retos del mundo digital. Este proyecto terminal no solo es el culmen de mi carrera, sino el inicio de un camino en el que aspiro a impactar positivamente la industria tecnológica.
      </p>
      <p>
        Mi compromiso es seguir innovando y aportar soluciones que enriquezcan la experiencia del usuario, generando un impacto real en nuestro entorno.
      </p>
    </div>
  );
};

export default About;
